import { useQuery } from '@tanstack/react-query';
import { backendServices } from 'common';

type Params = Omit<Parameters<backendServices.Apis.CompanyApi['getVatArchiveService']>[0], 'companyId'> & {
    companyId?: number;
};

export function useVatArchiveService({ companyId, $filter }: Params) {
    const query = useQuery(
        ['VatArchiveService', companyId, $filter],
        async () => {
            const api = new backendServices.Apis.CompanyApi();

            const res = await api.getVatArchiveService({ companyId: companyId!, $filter });

            return res.data;
        },
        { enabled: companyId != null, staleTime: Infinity, cacheTime: Infinity }
    );

    return query;
}
